export enum Location {
  Druckwerk = 'druckwerk',
  Kolon = 'kolon',
  Marzahn = 'marzahn',
  Rheinstr = 'rheinstr',
  Suhr = 'suhr',
}

export type Schedule = {
  location: Location;
  time: string;
};

type LocationRecord = {
  footnote?: string;
  id: string;
  text: string;
  url: string;
};

export const TRAINING_LOCATIONS: Record<Location, LocationRecord> = {
  [Location.Druckwerk]: {
    footnote: '\u2074 Parkplätze im Hinterhof.',
    id: 'druckwerk',
    text: 'Druckwerk Euren, Ottostr. 29, 54294 Trier\u2074',
    url: 'https://maps.app.goo.gl/XzjyacmmaYpryoNi7',
  },
  [Location.Kolon]: {
    footnote: '³ TomoSei Shin e.V.',
    id: 'kolon',
    text: 'Kolonnenstraße 26, 10829 Berlin³',
    url: 'https://maps.app.goo.gl/rC7C1jH38pFWEUV58',
  },
  [Location.Marzahn]: {
    footnote: '² Im Studio an der Rezeption nach Systema fragen.',
    id: 'marzahn',
    text: 'Grohsteig 3, 12679 Berlin²',
    url: 'https://maps.app.goo.gl/f6jveo1g7HMn8U3v7',
  },
  [Location.Rheinstr]: {
    footnote: '¹ Zweiter Hinterhof, Eingang 5, 1. Etage',
    id: 'rheinstr',
    text: 'Rheinstraße 45, 12161 Berlin¹',
    url: 'https://maps.app.goo.gl/1BUtm6rhxnwNx7zMA',
  },
  [Location.Suhr]: {
    id: 'suhr',
    text: 'Otto-Suhr-Allee 94, 10585 Berlin',
    url: 'https://maps.app.goo.gl/w4RASWP9mPvT6Tc9A',
  },
};
